import {OfferDisplayType} from "../helpers/OfferDisplayType";
import {IGetOfferListPayload} from "../types/GetOfferListPayload";

export const offerListConstraints: Pick<IGetOfferListPayload, "display_type" | "for_sale" | "limited_presentation" | "show_on_listing"> = {
    display_type: OfferDisplayType.FOR_SALE,
    for_sale: true,
    limited_presentation: false,
    show_on_listing: true
};
